import React, { useState } from 'react';
import classNames from 'classnames';

import css from './MobileSection.module.css';

/**
 * The mobile collapse for a listing-page section (P25009-443 BR-8/AC-8).
 *
 * The rule that makes collapsing safe: the header PRINTS the section's value
 * even when the body is closed — "Leverans · 249 kr" is a summary you can
 * choose to expand, a bare "Leverans" is a closed door. Sections whose value
 * the buyer came for (fitment) default open; depth defaults closed. Actions
 * are never put behind one of these — the price and Köp nu live in the
 * sticky bar.
 *
 * Desktop renders children untouched: the header is display:none above the
 * medium viewport and the body can never be hidden there. The body stays in
 * the DOM when closed (display:none), so the server-rendered HTML a crawler
 * reads is identical.
 */
const MobileSection = ({ label, value, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={css.root}>
      <button
        type="button"
        className={css.header}
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <span className={css.label}>{label}</span>
        {value ? <span className={css.value}>{value}</span> : null}
        <span className={css.chevron} aria-hidden="true">
          {open ? '⌃' : '⌄'}
        </span>
      </button>
      <div className={classNames(css.body, { [css.bodyClosed]: !open })}>{children}</div>
    </div>
  );
};

export default MobileSection;
